export default __webpack_public_path__ + "static/media/bg-be-active-subheader.5d31b49b.jpg";